module.exports = __webpack_public_path__ + "static/media/badges2x.f82f9b73.png";